import { useEffect } from 'react';
import { useSettings } from './useSettings';

export function useDocumentTitle() {
  const { settings, settingsKey } = useSettings();

  useEffect(() => {
    const base = settings?.general?.companyName || 'Studio Gori';
    let cancelled = false;
    fetch('/api/health')
      .then((r) => r.json())
      .then((data: { environment?: string }) => {
        if (cancelled) return;
        const env = data?.environment;
        document.title =
          env && env !== 'production'
            ? `${base} · ${env === 'development' ? 'develop' : env}`
            : base;
      })
      .catch(() => {
        if (!cancelled) document.title = base;
      });
    return () => {
      cancelled = true;
    };
  }, [settings?.general?.companyName, settingsKey]);
}
